import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import {
  Button,
  Icon,
  Modal,
  Popconfirm,
  Popover,
  message,
  Spin,
  Switch,
  Checkbox,
  DatePicker,
  Typography,
  notification,
} from "antd";
import { activateDevice, declencherGarantie } from "../../utils/apiBucherVaslin";
import HtmlIncluder from "../HtmlIncluder";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "./ActivateGuarantee.less";

// Total step number
const maxStep = 2;
const fileSize = "5";
const { Text } = Typography;

class ActivateDevice extends Component {
  state = {
    loading: false,
    visible: false,
    dealerCheckCGU: false,
    dealerCheckWarranty: false,
    step: 1,
    confirmationCheckbox: false,
    file: [],
    warrantyStartDate: moment(new Date()),
  };

  async activate() {
    console.log("Lancement de l'activation");
    let warrantySussess = false;
    let activateError = false;
    const { intl, refresh, isConnectedDevice, guaranteeIsValidate, fileName, askActivate } = this.props;
    // console.log(isConnectedDevice, guaranteeIsValidate);
    const { warrantyStartDate, file } = this.state;
    // console.log(warrantyStartDate, file );
    this.setState({ loading: true });
    this.hideModal();

    if(!fileName && askActivate){
        console.log("Activation enregistrement de la garantie");
        let { isSuccess, isUnauthorized } = await declencherGarantie(this.props, isConnectedDevice, guaranteeIsValidate, warrantyStartDate, file);
            isSuccess ? (
                warrantySussess = true,
                notification.success({
                    message: intl.formatMessage({ id: 'table.devices.guarantee.success' })
                })
            ) : (
                warrantySussess = false,
                this.setState({ loading: false }),
                notification.error({
                    message: (isUnauthorized) ?
                        intl.formatMessage({ id: 'error.unauthorized.title' }) :
                        intl.formatMessage({ id: 'table.devices.guarantee.error' }),
                    description: (isUnauthorized) ? intl.formatMessage({ id: 'error.unauthorized.message' }) : (
                        <a onClick={() => this.handleRedirect()}>
                            {intl.formatMessage({ id: 'table.devices.guarantee.error.contact' })}
                        </a>
                    ),
                })
            )
    }

    if(warrantySussess || fileName || !askActivate){

      const { intl, clientID, name, serial, refresh, askActivate } = this.props;
      
      const { isSuccess, isUnauthorized, errorMessage, errorDetail } =
        await activateDevice(serial, clientID);

      this.setState({ loading: false });

      if (isSuccess) {
        message.success(
          intl.formatMessage(
            {
              id: askActivate
                ? "device.activation.dealer.submitted"
                : "table.devices.activationModal.success",
            },
            { name }
          ),
          5
        );
        refresh();
        return;
      }
      else {
        activateError = true;
        Modal.error({
        title: isUnauthorized
            ? intl.formatMessage({ id: "error.unauthorized.title" })
            : intl.formatMessage({
                id: "table.devices.activationModal.fail",
            }),
        content: isUnauthorized
            ? intl.formatMessage({ id: "error.unauthorized.message" })
            : errorDetail,
        onOk: () => refresh(),
        });
      }
    }
    
    if(warrantySussess && !activateError || fileName && !activateError){
        refresh();
    }

  }

  /**
   * Method used when user confirm modal
   */
  confirm() {
    const { askActivate, warranty } = this.props;
    const { step } = this.state;

    // If user isn't dealer for this device
    if (!askActivate) {
      this.activate();
    } else {
      // If User is the dealer for this device
      if ((step === 1 && !warranty) || step === maxStep) {
        // User have validate all step, he's now able to proceed device activation
        this.activate();
      } else {
        // User havn't confirm all steps
        this.setState({ step: step + 1 });
      }
    }
  }

  /**
   * Method used to return corresponding label for "Ok" button
   */
  getOkButtonLabel() {
    const { askActivate, warranty } = this.props;
    const { step } = this.state;

    if (!warranty || step === maxStep) {
      // If all displayed step have been completed
      return askActivate ? "cgu.accept.dealer" : "cgu.accept";
    } else {
      // Else, display next step
      return "activateDevice.nextStep";
    }
  }

  hideModal() {
    this.setState({ visible: false });
  }

  /**
   * Method called when user confirm device activation
   */
  displayActivationModal() {
    const { intl, isNumeroEureka, ownerId } = this.props;
    if (!isNumeroEureka || !ownerId || ownerId === "NewCli") {
      // If device owner client haven't been validated yet => Show Info modal
      //console.log('modal de confirmation');
      Modal.info({
        content: (
          <div>
            {intl.formatMessage({
              id: "table.devices.activationInfoModal.description",
            })}
          </div>
        ),
        onOk() {},
      });
    } else {
      //console.log('modal de confirmation');
      // If client have been validated => Show confirmation modal
      this.setState({ visible: true });
    }
  }


//plus nécessaire à supprimer si nouvelle fonctionnalité acceptée
//   displayWarrantyForm = () => {
//     if (this.props.btnRef) {
//       console.log(this.props.btnRef);
//       document.getElementById(this.props.btnRef).click();
//     }
//   };

  // Update validation checkbox value
  async changeValidationCheck() {
    const { confirmationCheckbox } = this.state;
    await this.setState({ confirmationCheckbox: !confirmationCheckbox });
  }

  // Method used to get informations about General Terms of Sales
  getGTS() {
    const { intl } = this.props;
    const gts = {
      label: intl.formatMessage({ id: "gts.title" }),
      locale: intl.locale,
      link: "",
      linkWarranty: "",
    };

    switch (gts.locale) {
      case "fr":
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_french.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-fr.pdf";
        break;
      case "en":
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_english.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-en.pdf";
        break;
      case "de":
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_german.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-de.pdf";
        break;
      case "es":
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_spanish.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-es.pdf";
        break;
      case "it":
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_italian.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-it.pdf";
        break;
      default:
        gts.link =
          "/templates/pdf/general_terms_of_sales/general_terms_of_sales_english.pdf";
        gts.linkWarranty =
          "/templates/pdf/conditions_of_warranty/Contract RD-en.pdf";
        break;
    }

    return gts;
  }
  /**
   * Method used for dropzone and file management
   */
  handleDropzoneDrop = (acceptedFile) => {
    const files = this.state.file;
    this.setState({ file: acceptedFile, dealerCheckWarranty: true });
  };

  showRejectFileModal = () => {
    const { intl } = this.props;

    notification.error({
      duration: 10,
      message: (
        <span
          dangerouslySetInnerHTML={{
            __html: intl.formatHTMLMessage(
              { id: "contact.form.file.sizeLimit.error" },
              { fileSize: fileSize }
            ),
          }}
        ></span>
      ),
    });
  };

  removeFile = (event, index) => {
    event.stopPropagation();
    const copyFiles = this.state.files;
    copyFiles.splice(index, 1);
    this.setState({
      files: copyFiles,
      dealerCheckWarranty: false,
      confirmationCheckbox: false,
    });
  };
  render() {
    const { name, askActivate, authorizeTransfert, fileName } = this.props;
    const {
      loading,
      visible,
      dealerCheckCGU,
      dealerCheckWarranty,
      step,
      confirmationCheckbox,
      file,
      warrantyStartDate,
    } = this.state;
    const gts = visible ? this.getGTS() : null;
    //console.log(step);
    return (
      <Popover
        content={
          !authorizeTransfert ? (
            <FormattedMessage id="table.devices.impossible" />
          ) : (
            <FormattedMessage id="table.devices.activate" />
          )
        }
      >
        {/* {fileName ? ( */}
        <Popconfirm
          title={
            <FormattedMessage
              id="table.devices.activationModal.title"
              values={{ name }}
            />
          }
          okText={<FormattedMessage id="common.yes" />}
          cancelText={<FormattedMessage id="common.no" />}
          onConfirm={() => this.displayActivationModal()}
        >
          {loading ? (
            <Button htmlType="button">
              <Spin size="small" />
            </Button>
          ) : (
            <Button htmlType="button" disabled={!authorizeTransfert}>
              <Icon type="caret-right" />
            </Button>
          )}
        </Popconfirm>
        {/* ) : (
          <Popconfirm
            title={
              <FormattedMessage
                id="table.devices.activationModal.title.noWarranty"
                values={{ name }}
              />
            }
            okText={<FormattedMessage id="common.yes" />}
            cancelText={<FormattedMessage id="common.no" />}
            onConfirm={() => this.displayWarrantyForm()}
          >
            {loading ? (
              <Button htmlType="button">
                <Spin size="small" />
              </Button>
            ) : (
              <Button htmlType="button" disabled={!authorizeTransfert}>
                <Icon type="caret-right" />
              </Button>
            )}
          </Popconfirm>
        )} */}
        <Modal
          title={
            <FormattedMessage
              id={step === 1 ? "cgu.title" : "table.devices.guarantee"}
            />
          }
          visible={visible}
          okText={<FormattedMessage id={this.getOkButtonLabel()} />}
          cancelText={<FormattedMessage id="cgu.decline" />}
          onOk={() => this.confirm()}
          okButtonProps={{
            disabled: !askActivate 
              ? false
              : (step === 1 && (!dealerCheckCGU || !confirmationCheckbox)) ||
                (!dealerCheckWarranty && step === 2),
          }}
          onCancel={() => this.hideModal()}
          bodyStyle={{
            overflowY: "hidden",
            minHeight: "350px",
            position: "relative",
            display: askActivate ? "block" : "flex",
          }}
          width="70%"
          className="file-upload-form-item"
        >
          {/* Step 1 */}
          {step === 1 && (
            <Fragment>
              {askActivate && (
                <Fragment>
                  <Switch
                    checked={dealerCheckCGU}
                    onChange={(value) => {
                      this.setState({ dealerCheckCGU: value });
                    }}
                    className="alert-switch"
                  />
                  <FormattedMessage
                    id="device.activation.dealer.askOwnerCGU"
                    defaultMessage="Confirm that the machine belongs to you and that you will use it to make demos or provide services"
                  />
                </Fragment>
              )}

              <br></br>
              <span>
                <Checkbox
                  checked={confirmationCheckbox}
                  onChange={() => this.changeValidationCheck()}
                  style={{
                    marginRight: "1em",
                    marginLeft: "1em",
                    marginTop: "1em",
                  }}
                />
                <FormattedMessage id="device.modal.confirm.terms.of.sales" />
              </span>

              {/* List of informations link */}
              <ul style={{ marginTop: "1em" }}>
                {/* Link to General Terms of Sales */}
                {gts && (
                  <li>
                    <a target="_blank" href={gts.link}>
                      {gts.label}
                    </a>
                  </li>
                )}
              </ul>

              {(!askActivate || (dealerCheckCGU && confirmationCheckbox)) && (
                <HtmlIncluder
                  fileName="cgu"
                  isModalContent={true}
                  onLoad={(instance) => {
                    if (instance) {
                      instance.style.height =
                        "calc( 90vh - 100px - 56px - 50px - 42px - 53px - 47px )";
                    }
                  }}
                />
              )}
            </Fragment>
          )}

          {/* Step 2 */}
          {step === 2 && (
            <Fragment>
              <HtmlIncluder fileName="warranty" isModalContent={true} />
              <Fragment>
                <Text mark>
                  <FormattedMessage id="table.devices.guarantee.documentation" />
                </Text>
                <br />
                {gts && (
                  <ul style={{ marginTop: "1em" }}>
                    <li>
                      <a href={gts.linkWarranty} download>
                        <FormattedMessage id="table.devices.guarantee.documentation.pdf" />
                      </a>
                    </li>
                  </ul>
                )}

                <Dropzone
                  className="dropzone"
                  name="file"
                  multiple={false}
                  maxSize={fileSize * 1000000}
                  onDrop={this.handleDropzoneDrop}
                  onDropRejected={this.showRejectFileModal}
                  accept=".pdf"
                >
                  <Fragment>
                    {file && file.length > 0 ? (
                      <div className="file-container">
                        {file &&
                          file.map((fileElement, fileIndex) => (
                            <button
                              type="button"
                              key={fileElement.name}
                              className="file-name-container"
                              onClick={(e) => this.removeFile(e, fileIndex)}
                            >
                              <span className="file-name">
                                {fileElement.name}
                              </span>
                              <span className="file-delete">
                                <FontAwesomeIcon icon="times-circle" />
                              </span>
                            </button>
                          ))}
                      </div>
                    ) : null}

                    <div className="dropzone-content">
                      <span className="upload-icon">
                        <FontAwesomeIcon icon="file-upload" />
                      </span>
                    </div>
                  </Fragment>
                </Dropzone>
                <br />

                <span>
                  {<FormattedMessage id="table.devices.guaranteeDate" />}
                </span>
                <DatePicker
                  format="DD/MM/YY"
                  defaultValue={warrantyStartDate}
                  disabledDate={(d) => d.isAfter(new Date())}
                  disabled={true}
                  onChange={(date, dateString) => {
                    this.setState({ warrantyStartDate: date });
                  }}
                />
              </Fragment>
            </Fragment>
          )}
        </Modal>
      </Popover>
    );
  }
}

ActivateDevice.propTypes = {
  askActivate: PropTypes.bool.isRequired, // Si l'utilisateur est le concessionnaire de la machine alors la valeur est à true
  clientID: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  isNumeroEureka: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  ownerID: PropTypes.string,
  refresh: PropTypes.func.isRequired,
  serial: PropTypes.string.isRequired,
  warranty: PropTypes.bool.isRequired,
  authorizeTransfert: PropTypes.bool.isRequired,
};

export default injectIntl(ActivateDevice);
